export const INTERACTION_HIGHLIGHT_ACTIONS_MENU_OFFSET_TOP = 50;
export const PDF_HIGHLIGHT_SCROLL_TOP_OFFSET = 100; // can be removed if Toolbar UI is improved (e.g. placed at the bottom, prefer containerRef.offsetTop instead)
